import {citypairs} from "./cityPairs";
import {decodeHtml} from "../tools/tools";

const DECODE_HTML_ENTITIES = true;

const initializeCityPairs = (airports = []) => {

    if (!Array.isArray(airports)) {
        return [];
    }

    if (DECODE_HTML_ENTITIES) {
        for (let aIdx in airports) {
            const a = airports[aIdx];
            for (let pIdx in a) {
                const p = a[pIdx];
                if (p && (typeof p == 'string')) {
                    airports[aIdx][pIdx] = decodeHtml(p);
                }
            }
        }
    }

    return airports
        .map(airport => { //OSP
            const inAzores = airport.azores;
            const inPortugal = airport.countryName === 'Portugal';
            const destinationsOSP = airport.destinations.filter(code => {
                const destAirport = [...airports].filter(apt => apt.code === code)[0];
                return (destAirport && ((inAzores && destAirport.countryName === 'Portugal') || (inPortugal && destAirport.azores)));
            });

            return {...airport, value: airport, label: `${airport.name}  ${airport.code}`, destinationsOSP};
        })
        .sort((a, b) => a.name - b.name);
};

export const APP_CONFIGS = {
    APP: {
        name: 'SearchWidget',
        version: '0.0.9',
        defaultLanguage: 'pt',
        defaultCurrency: 'EUR'
    },
    API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
    CURRENCY_SYMBOLS: {
        EUR: '€',
        USD: '$',
        CAD: '$',
        GBP: '£'
    },
    CURRENT_PATH: window.currentPath || '/',
    CITY_PAIRS: {
        en: initializeCityPairs(process.env.REACT_APP_LOAD_MOCK_AIRPORTS ? citypairs.en : window.originListData),
        pt: initializeCityPairs(process.env.REACT_APP_LOAD_MOCK_AIRPORTS ? citypairs.pt : window.originListData),
    }
};